/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Link from "next/link";

import { LDBlockHeading, LDBlockDate, LDBlockParagraph } from "src/components/Splash/Layout/Typography";
import { LDLinkBlock } from "src/components/Splash/LDBlock";
import { PostAttrs } from "src/components/Splash/PostTemplate";
import { AppRoutes } from "src/lib/constants";

interface Props {
  post: PostAttrs;
}

export function PostCard({ post }: Props) {
  return (
    <Link href={`${AppRoutes.Blog}/${post.slug}`} passHref key={post.slug}>
      <LDLinkBlock>
        <LDBlockHeading>{post.title}</LDBlockHeading>
        <LDBlockDate>{post.date}</LDBlockDate>
        <LDBlockParagraph>{post.description}</LDBlockParagraph>
      </LDLinkBlock>
    </Link>
  );
}
